import { render, staticRenderFns } from "./languageCert.vue?vue&type=template&id=07a102e1&scoped=true&"
import script from "./languageCert.vue?vue&type=script&lang=js&"
export * from "./languageCert.vue?vue&type=script&lang=js&"
import style0 from "./languageCert.vue?vue&type=style&index=0&id=07a102e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a102e1",
  null
  
)

export default component.exports